export const mutations = {

  STORE_FILEOPENINGS(state, files){
    state.files = files
  },

 

  STORE_FILES(state, file_no){
    state.file_no = file_no
  },

  STORE_FILEOPENING_UPDATE(state, fileopening_id){
    let  File = state.files.find(function(file){
      return file.id === fileopening_id
    })
    state.systemFileopening = File
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/fileopenings/mutations.js